module.exports = __webpack_public_path__ + "static/media/wheel-active.f107f767.svg";